import { render, staticRenderFns } from "./JobBenefitsEditModal.vue?vue&type=template&id=458d7236"
import script from "./JobBenefitsEditModal.vue?vue&type=script&lang=js"
export * from "./JobBenefitsEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports